export default __webpack_public_path__ + "static/media/star_black_24dp.ecf2636e.svg";